import { render, staticRenderFns } from "./ProductListingShow.vue?vue&type=template&id=0fcd152c&"
import script from "./ProductListingShow.vue?vue&type=script&lang=js&"
export * from "./ProductListingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports